// extracted by mini-css-extract-plugin
export default {"flexRow":"flex-row_flexRow__Fu16d"};